
// 消息相关接口
import request from '@/utils/request'

// 用户反馈列表
export function userFeedback(query) {
  return request({
    url: '/biz/userFeedback/pageList',
    method: 'get',
    params: query
  })
}

// 处理用户反馈状态
export function changeUserFeedback(query) {
  return request({
    url: '/biz/userFeedback/updateComplaints',
    method: 'post',
    params: query
  })
}

// 加盟学校列表
export function joinSchoolList(query) {
  return request({
    url: '/biz/joinSchool/list',
    method: 'get',
    params: query
  })
}

// 处理加盟学校状态
export function joinSchoolState(query) {
  return request({
    url: '/biz/joinSchool/updateTreatmentState',
    method: 'put',
    params: query
  })
}

// 消息列表====================start
export function messageList(query) {
  return request({
    url: '/biz/message/list',
    method: 'get',
    params: query
  })
}
// 消息列表====================end

// 消息模板====================start
export function msgTemplateList(query) {
  return request({
    url: '/biz/msgTemplate/list',
    method: 'get',
    params: query
  })
}
// 消息模板====================end